export default __webpack_public_path__ + "static/media/Warhammer40,000DawnofWarseries.ac70acf8.jpg";